import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2112">
      <div className="dark" data-id="element-2113">
        <Hero data-id="element-2114" />
      </div>
      <WhyUs data-id="element-2115" />
      <Services data-id="element-2116" />
      <HowItWorks data-id="element-2117" />
      <FAQ data-id="element-2118" />
      <Reviews data-id="element-2119" />
      <CtaBanner data-id="element-2120" />
    </main>;
}